import React from "react";
import { Helmet } from "@/components/Helmet";
import { getHost, getSubjectDetailUrl } from "@/utils/URL";
import { toUpperCaseWords } from "@/utils/formatTools";

const SubjectDetailHelmet = (props: {
  subjectWord: string;
  bookNames?: string[];
  topicId: string | number;
}) => {
  const { subjectWord, bookNames = [], topicId } = props;
  const keyWord = toUpperCaseWords(subjectWord);
  const title = `${keyWord} Novels & Stories - Chereads`;
  const description = `Read ${keyWord} stories online for free. We provide the most popular ${keyWord} light novel like: ${bookNames
    .slice(0, 3)
    .join(", ")}.`;
  const keywords = `${keyWord}, ${keyWord} novels, ${keyWord} stories, fanfic, fiction books, chereads`;

  const canonical = `${getHost()}${getSubjectDetailUrl(`${topicId}`)}`;

  return (
    <Helmet title={title} description={description} keywords={keywords}>
      <link rel="canonical" href={canonical} />
    </Helmet>
  );
};

export default SubjectDetailHelmet;
